import './FileCard.scss';
import { RxCross2 } from 'react-icons/rx';
import React from 'react';
import { Checkbox } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import useCreateScreening from '../../../hooks/useCreateScreening';
import { t } from '../../../i18n/i18n';

function FileCard({ index, question, types, id, handleDelete, setDataAI }) {
  const { fileTypes } = useCreateScreening();

  const handleUpdateData = (e, id) => {
    const { name, value, checked, type } = e.target;

    if (type === 'checkbox') {
      setDataAI((prevState) =>
        prevState.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              [name]: checked
                ? [...item.types, value]
                : item.types.filter((type) => type !== value),
            };
          }
          return item;
        })
      );
    } else {
      setDataAI((prevState) =>
        prevState.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              [name]: value,
            };
          }
          return item;
        })
      );
    }
  };

  return (
    <div className="file-card-container">
      <div className="file-card-index-badge">
        <span>{index}</span>
      </div>
      <div className="file-card-content">
        <span className="card-text">{t('WRITE_CART_SUBTITLE_QUESTION')}: </span>
        <TextArea
          type="text"
          name="question"
          value={question ?? ''}
          className={`file-card-textarea ${
            question?.length ? 'selected-border' : 'unselected-border'
          }`}
          placeholder={t('CREATE_SCREENING_YOUR_QUESTIONS_WRITE_YOU_QUESTION_PLACEHOLDER')}
          rows={4}
          data-testid="question-wf-textarea"
          onChange={(e) => handleUpdateData(e, id)}
        />

        <p className="file-card-subtitle">
          {t('CREATE_SCREENING_YOUR_QUESTIONS_FILE_MULTIPLE_SELECT_PLACEHOLDER')}:
        </p>
        <div className="file-card-filetypes-container">
          {Boolean(fileTypes?.length) &&
            fileTypes?.map((fileType) => (
              <div key={fileType.id} className="file-card-filetype-item">
                <Checkbox
                  className="checkbox-files-item"
                  name="types"
                  value={fileType?.id}
                  checked={types?.includes(fileType?.id)}
                  onChange={(e) => handleUpdateData(e, id)}
                />
                <div>
                  {fileType?.displayName?.split('/').map((item, index) => (
                    <p
                      key={item}
                      className={`file-card-filetype-text ${
                        index === 1 ? 'file-card-filetype-secondary' : ''
                      }`}
                      data-testid="question-wf-your-files-span"
                    >
                      {item}
                    </p>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="file-card-remove">
        <RxCross2 onClick={() => handleDelete(id)} />
      </div>
    </div>
  );
}

export default FileCard;
